import React, {useState} from 'react';
import * as S from './SrpFilterLoader.styles';
import LineLoader from '../../../../../../stories/core-components/LineLoader/LineLoader';

const SrpFilterLoader = () => {
  return (
    <S.FilterLoaderWrap>
      <S.FilterMainHeader>
        <S.FilterTitle>Filters</S.FilterTitle>
        <S.ResetElink>Clear All</S.ResetElink>
      </S.FilterMainHeader>
      <S.FilterBlock>
        <S.FilterHeaderBlock>
          <S.FilterHeaderTxt>Popular</S.FilterHeaderTxt>
          <S.ResetLink>Reset</S.ResetLink>
        </S.FilterHeaderBlock>
        <S.FilterContentBlock>
          <LineLoader />
          <LineLoader />
        </S.FilterContentBlock>
      </S.FilterBlock>

      <S.FilterBlock>
        <S.FilterHeaderBlock>
          <S.FilterHeaderTxt>Bus Type</S.FilterHeaderTxt>
          <S.ResetLink>Reset</S.ResetLink>
        </S.FilterHeaderBlock>
        <S.FilterContentBlock>
          <LineLoader />
          <LineLoader />
        </S.FilterContentBlock>
      </S.FilterBlock>

      <S.FilterBlock>
        <S.FilterHeaderBlock>
          <S.FilterHeaderTxt>Departure Time</S.FilterHeaderTxt>
          <S.ResetLink>Reset</S.ResetLink>
        </S.FilterHeaderBlock>
        <S.FilterContentBlock>
          <LineLoader />
          <LineLoader />
        </S.FilterContentBlock>
      </S.FilterBlock>

      <S.FilterBlock>
        <S.FilterHeaderBlock>
          <S.FilterHeaderTxt>Arrival Time</S.FilterHeaderTxt>
          <S.ResetLink>Reset</S.ResetLink>
        </S.FilterHeaderBlock>
        <S.FilterContentBlock>
          <LineLoader />
          <LineLoader />
        </S.FilterContentBlock>
      </S.FilterBlock>

      <S.FilterBlock>
        <S.FilterHeaderBlock>
          <S.FilterHeaderTxt>Boarding Point</S.FilterHeaderTxt>
          <S.ResetLink>Reset</S.ResetLink>
        </S.FilterHeaderBlock>
        <S.FilterContentBlock>
          <LineLoader />
          <LineLoader />
        </S.FilterContentBlock>
      </S.FilterBlock>

      <S.FilterBlock>
        <S.FilterHeaderBlock>
          <S.FilterHeaderTxt>Dropping Point</S.FilterHeaderTxt>
          <S.ResetLink>Reset</S.ResetLink>
        </S.FilterHeaderBlock>
        <S.FilterContentBlock>
          <LineLoader />
          <LineLoader />
        </S.FilterContentBlock>
      </S.FilterBlock>

      <S.FilterBlock>
        <S.FilterHeaderBlock>
          <S.FilterHeaderTxt>Dropping Point</S.FilterHeaderTxt>
          <S.ResetLink>Reset</S.ResetLink>
        </S.FilterHeaderBlock>
        <S.FilterContentBlock>
          <LineLoader />
          <LineLoader />
        </S.FilterContentBlock>
      </S.FilterBlock>

      <S.FilterBlock>
        <S.FilterHeaderBlock>
          <S.FilterHeaderTxt>Bus Operator</S.FilterHeaderTxt>
          <S.ResetLink>Reset</S.ResetLink>
        </S.FilterHeaderBlock>
        <S.FilterContentBlock>
          <LineLoader />
          <LineLoader />
        </S.FilterContentBlock>
      </S.FilterBlock>

      <S.FilterBlock>
        <S.FilterHeaderBlock>
          <S.FilterHeaderTxt>Amenities</S.FilterHeaderTxt>
          <S.ResetLink>Reset</S.ResetLink>
        </S.FilterHeaderBlock>
        <S.FilterContentBlock>
          <LineLoader />
          <LineLoader />
        </S.FilterContentBlock>
      </S.FilterBlock>
    </S.FilterLoaderWrap>
  );
};

export default SrpFilterLoader;
